import { unescape } from 'lodash-es';
/**
 * Если какие-то свойства в сеттингах содержат html и
 * они нужны не только для отображения в верстке(а, например, ещё в title блока)
 * то их нужно разэскейпить от спецсимволов html
 */
let vars = window.__INITIAL__DJANGO__;
vars.settings.footer_description.text = unescape(vars.settings.footer_description.text);
export default vars;
